// Candado SUAVE de grupo (F2, spec §2): para estar en un grupo hay que estar
// inscrito en la temporada abierta de ese deporte. 'Pendiente' CUENTA.
//
// No se exige "realmente activo" a proposito: inscribir es un clic y no pide CURP
// ni consentimiento -- es solo la decision "participa este ciclo", que es lo unico
// que el coach si puede contestar. Exigir el papeleo dejaria a un club entero
// fuera de sus equipos por firmas que no dependen de el (RAIDERS TRC: 196
// jugadores en Pendiente recabando consentimientos). El papeleo se vigila con los
// indicadores de estatus dentro del grupo, no bloqueando al coach.
//
// Puro: sin I/O. Recibe lo ya consultado.

// Temporada donde deberia estar inscrito quien entra a un grupo de este deporte.
// null si no hay ninguna abierta, o si hay 2+ (ambiguo: no se adivina).
export const temporadaDestino = (temporadasAbiertasDelDeporte = []) =>
  temporadasAbiertasDelDeporte.length === 1 ? temporadasAbiertasDelDeporte[0] : null

// Reparte a los jugadores segun si el candado los deja pasar.
// inscripcionesByJugador: { [jugadorId]: { estatus } } de la temporada destino.
export const evaluarCandado = ({ jugadorIds = [], inscripcionesByJugador = {} } = {}) => {
  const pasan = []
  const faltanInscripcion = []
  for (const id of jugadorIds) {
    const insc = inscripcionesByJugador[id]
    // Una baja no habilita: se dio de baja del ciclo, hay que reinscribirlo.
    if (insc && insc.estatus !== 'baja') pasan.push(id)
    else faltanInscripcion.push(id)
  }
  return { pasan, faltanInscripcion }
}

// Sin temporada abierta el candado NO aplica: no hay donde inscribir, y bloquear
// dejaria al club sin poder armar equipos hasta que abra una. El candado exige la
// inscripcion cuando es posible tenerla, no castiga por algo imposible.
export const candadoAplica = (temporada) => !!temporada
